import React from 'react';
import { ArrowRight, Github, Linkedin, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { personalInfo } from '../mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-white pt-20">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center space-y-8">
          {/* Avatar */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-cyan-600 shadow-xl">
                <img
                  src={personalInfo.avatar}
                  alt={personalInfo.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-green-500 rounded-full border-4 border-white"></div>
            </div>
          </div>

          {/* Name and Title */}
          <div className="space-y-4">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 tracking-tight">
              {personalInfo.name}
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 font-medium">
              {personalInfo.title}
            </p>
            <p className="text-lg md:text-xl text-gray-500">
              {personalInfo.subtitle}
            </p>
          </div>

          {/* Social Links */}
          <div className="flex justify-center items-center space-x-6 pt-4">
            <a
              href={personalInfo.socials.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-cyan-600 transition-all hover:scale-110"
            >
              <Github size={28} />
            </a>
            <a
              href={personalInfo.socials.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-cyan-600 transition-all hover:scale-110"
            >
              <Linkedin size={28} />
            </a>
            <a
              href={personalInfo.socials.email}
              className="text-gray-700 hover:text-cyan-600 transition-all hover:scale-110"
            >
              <Mail size={28} />
            </a>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 pt-8">
            <Button
              size="lg"
              onClick={() => scrollToSection('projects')}
              className="bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-6 text-lg group"
            >
              View My Work
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('contact')}
              className="border-2 border-gray-300 hover:border-cyan-600 hover:text-cyan-600 px-8 py-6 text-lg"
            >
              Get In Touch
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="pt-16 animate-bounce">
            <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-gray-400 rounded-full mt-2"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;